import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TabCollectPageRoutingModule } from './tab-collect-routing.module';

import { TabCollectPage } from './tab-collect.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TabCollectPageRoutingModule
  ],
  declarations: [TabCollectPage]
})
export class TabCollectPageModule {}
